import { httpPost } from '@/api/httpClient';

export type SmaltCoreIngestSyncRequest = {
  platformProjectId: number;
};

export type SmaltCoreIngestSyncResponse = {
  coreProject: { code: string; created: boolean; id: number; ingest_key?: string };
  attributes: { created: number; updated: number; skipped: number; invalid: number };
};

export type SmaltCoreOrphanDevicesResponse = {
  attributeCount: number;
  deviceCount: number;
  deviceNames: string[];
};

export type SmaltCoreIngestCheckResponse = {
  coreProject: { code: string; exists: boolean; id?: number };
  summary: { total: number; ok: number; missing: number; mismatched: number; invalid: number };
  problems: Array<{
    platformAttributeId: number;
    uuid: string | null;
    name: string;
    type: string;
    message: string;
    diffs?: Record<string, { expected: unknown; actual: unknown }>;
  }>;
};

export const smaltCoreIngestSyncApi = {
  sync: (platformProjectId: number) =>
    httpPost<SmaltCoreIngestSyncResponse, SmaltCoreIngestSyncRequest>(
      '/admin/smalt-core-ingest/sync',
      { platformProjectId }
    ),
  check: (platformProjectId: number) =>
    httpPost<SmaltCoreIngestCheckResponse, SmaltCoreIngestSyncRequest>(
      '/admin/smalt-core-ingest/check',
      { platformProjectId }
    ),
  orphanDevices: (platformProjectId: number) =>
    httpPost<SmaltCoreOrphanDevicesResponse, SmaltCoreIngestSyncRequest>(
      '/admin/smalt-core-ingest/orphan-devices',
      { platformProjectId }
    ),
};

